import { render, staticRenderFns } from "./TUWEN014.vue?vue&type=template&id=2079fe6c"
import script from "./TUWEN014.vue?vue&type=script&lang=js"
export * from "./TUWEN014.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports